import React from "react";
import { FaGavel, FaExclamationTriangle, FaShoppingBag, FaExchangeAlt, FaBan, FaUser, FaShieldAlt, FaFileContract } from "react-icons/fa";
import { FaTruck } from "react-icons/fa";

export default function TermsAndConditions() {
  return (
    <div className="mt-8 py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <h1 className="text-3xl font-bold text-[#D4AF37] mb-8">Terms & Conditions</h1>

        {/* Legal Introduction */}
        <div className="mb-8 p-4 rounded-lg border border-[#D4AF37]">
          <h3 className="text-lg font-semibold text-[#D4AF37] mb-3">Legal Framework</h3>
          <p className="text-sm mb-3">
            This document is an electronic record in terms of Information Technology Act, 2000 and rules 
            thereunder as applicable. This electronic record is generated by a computer system and does not 
            require any physical or digital signatures.
          </p>
          <p className="text-sm mb-3">
            This document is published in accordance with the provisions of Rule 3(1) of the Information 
            Technology (Intermediaries guidelines) Rules, 2011 for the domain https://www.mashoperfumes.com/.
          </p>
          <p className="text-sm">
            The Platform is owned by <strong className="text-[#D4AF37]">MASHO PERFUMES</strong>, a company incorporated under the Companies Act, 1956 with its registered office at Malappuram, Kerala, India.
          </p>
        </div>

        {/* Agreement Notice */}
        <div className="mb-8 p-4 bg-red-900/20 rounded-lg border border-red-500">
          <h3 className="text-lg font-semibold text-red-400 mb-3 flex items-center">
            <FaExclamationTriangle className="mr-2" /> Important Notice
          </h3>
          <p className="text-sm font-semibold">
            ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE. PLEASE READ CAREFULLY BEFORE PROCEEDING.
          </p>
        </div>

        {/* Section 1: User Agreement */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaUser className="mr-2 text-[#D4AF37]" /> User Agreement & Registration
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>
              By mere use of the Platform, you shall be contracting with MASHO PERFUMES and these terms constitute your binding obligations.
            </li>
            <li>
              To access and use our Services, you agree to provide true, accurate and complete information during and after registration.
            </li>
            <li>
              You shall be responsible for all acts done through the use of your registered account on the Platform.
            </li>
            <li>
              Any terms proposed by you which conflict with these Terms are expressly rejected and shall be of no force or effect.
            </li>
            <li>
              These Terms can be modified at any time without assigning any reason. It is your responsibility to periodically review these Terms.
            </li>
          </ul>
        </div>

        {/* Section 2: Product Usage Guidelines */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaExclamationTriangle className="mr-2 text-[#D4AF37]" /> Product Guidelines
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>
              <strong>Fragrance Enhancement:</strong> For optimal experience, store unopened perfumes at room temperature 
              for <span className="text-[#D4AF37]">3-7 hours</span> before first use to allow the fragrance to mature.
            </li>
            <li>Keep away from direct sunlight and extreme temperatures.</li>
            <li>Test on a small skin area before full application to check for allergies.</li>
            <li>Not for internal use - keep away from children and pets.</li>
            <li>You are required to independently assess and ensure that the Services meet your requirements.</li>
          </ul>
        </div>

        {/* Section 3: Orders & Payments */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaShoppingBag className="mr-2 text-[#D4AF37]" /> Orders & Payments
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>All prices are in INR and inclusive of GST where applicable.</li>
            <li>We accept UPI, credit/debit cards, net banking, and select wallets.</li>
            <li>Orders are processed within 1-2 business days (excluding weekends/holidays).</li>
            <li>You agree to pay us the charges associated with availing the Services.</li>
            <li>Upon initiating a transaction, you are entering into a legally binding and enforceable contract with MASHO PERFUMES.</li>
            <li>We reserve the right to cancel any order for reasons including pricing errors or stock unavailability.</li>
          </ul>
        </div>

        {/* Section 4: Shipping */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaTruck className="mr-2 text-[#D4AF37]" /> Shipping Policy
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>Kerala deliveries: ₹120 shipping fee</li>
            <li>All other Indian states: ₹180 shipping fee</li>
            <li>Delivery timelines: Kerala (2-3 business days), Rest of India (3-7 business days)</li>
            <li>A signature may be required upon delivery</li>
            <li>Remote locations may take longer and incur additional charges</li>
          </ul>
        </div>

        {/* Section 5: Returns & Refunds */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaExchangeAlt className="mr-2 text-[#D4AF37]" /> Returns & Refunds
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>Unopened products may be returned within 7 days of delivery.</li>
            <li>Defective products must be reported within 48 hours with photo/video evidence.</li>
            <li>Original packaging and tags must be intact for returns.</li>
            <li>Refunds are processed within 5-7 business days after return approval.</li>
            <li>Shipping fees are non-refundable unless the return is due to our error.</li>
            <li>Failed deliveries (after 3 courier attempts) result in automatic refunds minus shipping fees (unless return is due to our error).</li>
          </ul>
        </div>

        {/* Section 6: Prohibited Uses */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaBan className="mr-2 text-[#D4AF37]" /> Prohibited Activities
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>You agree not to use the Platform for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws.</li>
            <li>Reselling our products as your own brand</li>
            <li>Commercial use without written permission</li>
            <li>Attempting to reverse-engineer our fragrances</li>
            <li>Submitting fraudulent orders or chargebacks</li>
            <li>Unauthorized use of the Platform may lead to action against you as per these Terms and/or applicable laws.</li>
          </ul>
        </div>

        {/* Section 7: Intellectual Property */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaGavel className="mr-2 text-[#D4AF37]" /> Intellectual Property
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>The contents of the Platform and Services are proprietary to us and are licensed to us.</li>
            <li>You will not have any authority to claim any intellectual property rights, title, or interest in its contents.</li>
            <li>The contents include and are not limited to the design, layout, look and graphics.</li>
            <li>All product names, logos, and fragrance compositions are MASHO Perfumes' property.</li>
            <li>Unauthorized duplication of our products is prohibited.</li>
            <li>Customer reviews/photos may be used for promotional purposes.</li>
          </ul>
        </div>

        {/* Section 8: Disclaimers & Warranties */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaShieldAlt className="mr-2 text-[#D4AF37]" /> Disclaimers & Warranties
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>
              Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, 
              performance, completeness or suitability of the information and materials offered on this website.
            </li>
            <li>
              You acknowledge that such information and materials may contain inaccuracies or errors and we expressly 
              exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
            </li>
            <li>Your use of our Services and Platform is solely and entirely at your own risk and discretion.</li>
            <li>We shall not be liable to you in any manner for your use of the Services.</li>
          </ul>
        </div>

        {/* Section 9: Limitations of Liability */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4">
            Limitations of Liability
          </h3>
          <p className="text-sm mb-2">
            MASHO Perfumes shall not be liable for:
          </p>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>Any allergic reactions or skin sensitivities</li>
            <li>Delivery delays due to unforeseen circumstances (weather, logistics, courier issues)</li>
            <li>Minor color variations in product images</li>
            <li>Changes in fragrance notes due to natural ingredients</li>
            <li>Any failure to perform an obligation if performance is prevented or delayed by a force majeure event</li>
          </ul>
        </div>

        {/* Section 10: Third Party Links */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4">
            Third Party Links
          </h3>
          <p className="text-sm">
            You agree and acknowledge that the website and Services may contain links to other third party websites. 
            On accessing these links, you will be governed by the terms of use, privacy policy and such other policies 
            of such third party websites. These links are provided for your convenience to provide further information.
          </p>
        </div>

        {/* Section 11: Indemnification */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
            <FaFileContract className="mr-2 text-[#D4AF37]" /> Indemnification
          </h3>
          <p className="text-sm">
            You shall indemnify and hold harmless MASHO PERFUMES, its affiliates, group companies and their respective 
            officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorney's 
            fees, made by any third party or penalty imposed due to or arising out of your breach of these Terms of Use, 
            Privacy Policy and other Policies, or your violation of any law, rules or regulations or the rights 
            (including infringement of intellectual property rights) of a third party.
          </p>
        </div>

        {/* Section 12: Governing Law */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4">
            Governing Law & Jurisdiction
          </h3>
          <ul className="list-disc pl-6 text-sm space-y-2">
            <li>These Terms and any dispute or claim relating to it shall be governed by and construed in accordance with the laws of India.</li>
            <li>All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Malappuram and Kerala.</li>
          </ul>
        </div>

        {/* Section 13: Changes to Terms */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4">
            Changes to Terms
          </h3>
          <p className="text-sm">
            We may update these terms periodically. Continued use of our services constitutes acceptance of the revised terms.
          </p>
        </div>

        {/* Contact Information */}
        <div className="mt-8 p-4 rounded-lg border border-[#D4AF37]">
          <h3 className="text-lg font-semibold text-[#D4AF37] mb-3">Contact Us</h3>
          <p className="text-sm">
            All concerns or communications relating to these Terms must be communicated to us using the contact 
            information provided on this website.
          </p>
        </div>
      </div>
    </div>
  );
}